// Solution FINALE - Écouter l'événement cartUpdate du thème
function updateFreeShippingProgress() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const threshold = window.settings?.cart_free_shipping_threshold * 100 || 0;
      const total = cart.total_price;
      
      const barWrapper = document.querySelector('.FreeShippingBar');
      if (!barWrapper) return;
      
      if (total > 0 && total < threshold) {
        // Panier non vide ET seuil non atteint = montrer la barre
        barWrapper.classList.remove('is-hidden');
        
        const fill = document.querySelector('.FreeShippingBar__Fill');
        const amountSpan = document.querySelector('.ShippingNotice__Remaining');
        
        const percent = Math.min(100, Math.round((total / threshold) * 100));
        const remaining = threshold - total;
        
        if (fill) {
          fill.style.width = `${percent}%`;
        }
        
        if (amountSpan) {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            amountSpan.textContent = Shopify.formatMoney(remaining, "{{amount_with_comma_separator}} €");
          } else {
            const euros = (remaining / 100).toFixed(2).replace('.', ',');
            amountSpan.textContent = `${euros} €`;
          }
        }
      } else {
        // Panier vide OU livraison gratuite = garder la barre cachée
        barWrapper.classList.add('is-hidden');
      }
    });
}

// ÉCOUTER L'ÉVÉNEMENT DU THÈME qui se déclenche APRÈS le rechargement HTML
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, updateFreeShippingProgress);
}

// Initialisation
document.addEventListener('DOMContentLoaded', updateFreeShippingProgress);